export default __webpack_public_path__ + "static/media/faceC-victory.3f392ec1.png";